import * as React from "react";
const SvgFiRrPhotoFilmMusic = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-photo-film-music_svg__a)">
      <path
        fill="#062147"
        d="M9 22H6V11a1 1 0 0 0-1-1h-.5A4.505 4.505 0 0 0 0 14.5v5C0 21.981 2.019 24 4.5 24H9a1 1 0 1 0 0-2m-7-6h2v2H2zm2-3.95V14H2.055c.2-.977.968-1.75 1.945-1.95M2.055 20H4v1.95A2.5 2.5 0 0 1 2.055 20M19 0h-6c-2.757 0-5 2.243-5 5v4a4.996 4.996 0 0 0 3.751 4.842q.125.032.25.032a.999.999 0 0 0 .248-1.968 3 3 0 0 1-.366-.128l4.406-3.782.475.48c.779.78 2.049.78 2.828 0L22 6.068V9a1 1 0 1 0 2 0V5c0-2.757-2.243-5-5-5m-.818 7.066-.474-.479a1.993 1.993 0 0 0-2.706-.114l-4.632 3.97A3 3 0 0 1 10 9V5c0-1.654 1.346-3 3-3h6a2.99 2.99 0 0 1 2.638 1.602zM14 4.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 14 4.5M24 15v6.5a2.5 2.5 0 1 1-2-2.45V15c0-.551-.448-1-1-1h-3c-.552 0-1 .449-1 1v6.5a2.5 2.5 0 1 1-2-2.45V15c0-1.654 1.346-3 3-3h3c1.654 0 3 1.346 3 3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-photo-film-music_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPhotoFilmMusic;
